import {safelyGetStorageItem} from '@vio/core/src/_web/utils/persistence/safelyGetStorageItem'
import {safelySetStorageItem} from '@vio/core/src/_web/utils/persistence/safelySetStorageItem'

export const DF_ONBOARDING_SEEN_STORAGE_KEY = 'dealFreezeOnboardingSeen'

export const hasSeenDealFreezeOnboarding = (): boolean =>
  safelyGetStorageItem(
    'localStorage',
    DF_ONBOARDING_SEEN_STORAGE_KEY,
    'hasSeenDealFreezeOnboarding failed'
  ) === 'true'

export const setDealFreezeOnboardingSeen = (): void => {
  safelySetStorageItem(
    'localStorage',
    DF_ONBOARDING_SEEN_STORAGE_KEY,
    'true',
    'setDealFreezeOnboardingSeen failed'
  )
}
